module.exports = __webpack_public_path__ + "static/photo-nicolas-eaff4ef61df894d99671f02930b88979.jpg";